import {
  AppFunctionComponent,
  CustomFullWidthImage,
  SingleQueryResult,
} from "../../../../../types"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import {
  StyledGalleryContainer,
  StyledGalleryWrapper,
  StyledGatsbyImage,
} from "./full-width-image.styled"

const FullWidthImage: AppFunctionComponent = () => {
  const {
    content: { images },
  } = useStaticQuery<SingleQueryResult<CustomFullWidthImage>>(query)

  return (
    <StyledGalleryContainer>
      <StyledGalleryWrapper>
        <StyledGatsbyImage
          key={12}
          image={images[0].gatsbyImageData}
        ></StyledGatsbyImage>
      </StyledGalleryWrapper>
    </StyledGalleryContainer>
  )
}

const query = graphql`
  query MuditaFullWidthImageCustomComponent {
    content: contentfulCustomComponent(custom: { eq: "full width image" }) {
      images {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, quality: 100)
      }
    }
  }
`

export default FullWidthImage
